module.exports = __webpack_public_path__ + "img/loader.3305f4fe.gif";